import React from 'react';

const TechieScoreBar = ({ score, compact = false, showLabel = true, summary }) => {
  const percentage = (score / 10) * 100;
  
  // Color based on score
  const getScoreColor = (score) => {
    if (score <= 3) return '#EF4444'; // Red
    if (score <= 6) return '#F97316'; // Orange  
    if (score <= 8) return '#22C55E'; // Green
    return '#3B82F6'; // Blue
  };

  const getScoreLabel = (score) => {
    if (score <= 3) return 'Poor';
    if (score <= 6) return 'Moderate';
    if (score <= 8) return 'Good';
    return 'Excellent';
  };

  const color = getScoreColor(score);
  const label = getScoreLabel(score);

  if (compact) {
    return (
      <div className="group relative">
        <span 
          className="inline-flex items-center px-3 py-1 rounded-lg text-sm font-bold text-white shadow-sm"
          style={{ 
            backgroundColor: color
          }}
        >
          {score.toFixed(1)}
        </span>
        
        {summary && (
          <div className="text-center absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 dark:bg-gray-700 text-white dark:text-gray-200 text-xs rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10whitespace-nowrap">
            <span className="mr-1 text-amber-600 dark:text-amber-400">TechieScore:</span><br/>
            <span className="break-word">{summary}</span>
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900 dark:border-t-gray-700"></div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-2 group relative">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
          TechieDay Score
        </span>
        <span className="text-sm font-bold text-gray-900 dark:text-gray-100">
          {score.toFixed(1)} / 10
        </span>
      </div>
      
      <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-700 ease-out"
          style={{
            width: `${percentage}%`,
            backgroundColor: color
          }}
        />
      </div>
      
      {summary && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 dark:bg-gray-700 text-white dark:text-gray-200 text-xs rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10">
          <span className="mr-1 text-amber-600 dark:text-amber-400">TechieScore:</span><br/>
          <span className="break-word">{summary}</span>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900 dark:border-t-gray-700"></div>
        </div>
      )}
      
      {showLabel && (
        <div className="flex justify-between items-center">
          <span 
            className="text-xs font-medium px-2 py-1 rounded-full"
            style={{ 
              color: color,
              backgroundColor: `${color}15`,
              border: `1px solid ${color}30`
            }}
          >
            {label}
          </span>
          <span className="text-xs text-gray-500 dark:text-gray-400">
            Based on 1,234 reviews
          </span>
        </div>
      )}
    </div>
  );
};

export default TechieScoreBar;
